export default {
  alaska: {
    name: 'Alaska Airlines Mileage Plan™',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Alaska-Airlines_Mileage-Plan.zip',
  },
  ally: {
    name: 'Ally',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Ally.zip',
  },
  alterra: {
    name: 'Alterra',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Alterra_Home-Loans.zip',
  },
  amazon: {
    name: 'Amazon',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Amazon-Prime_Rewards.zip',
  },
  amex: {
    name: 'American Express',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/AmEx.zip',
  },
  ascent: {
    name: 'Ascent',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Ascent.zip',
  },
  axos: {
    name: 'Axos',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Axos.zip',
  },
  bbva: {
    name: 'BBVA',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/BBVA_Business-Connect.zip',
  },
  better: {
    name: 'Better.com',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Better.com.zip',
  },
  betterment: {
    name: 'Betterment',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Betterment_Premium.zip',
  },
  capitalone: {
    name: 'Capital One',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Capital-One.zip',
  },
  charlesschwab: {
    name: 'Charles Schwab',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Charles-Schwab.zip',
  },
  chase: {
    name: 'JPMorgan Chase',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Chase.zip',
  },
  chime: {
    name: 'Chime',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Chime.zip',
  },
  citi: {
    name: 'Citibank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Citi_Double-Cash.zip',
  },
  collegeave: {
    name: 'College Ave',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/College-Ave.zip',
  },
  commonbond: {
    name: 'CommonBond',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/CommonBond.zip',
  },
  connexus: {
    name: 'Connexus Credit Union',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Connexus-Credit-Union.zip',
  },
  delta: {
    name: 'Delta SkyMiles',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Delta-SkyMiles_Gold-AmEx.zip',
  },
  discover: {
    name: 'Discover',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Discover.zip',
  },
  earnest: {
    name: 'Earnest',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Earnest.zip',
  },
  ellevest: {
    name: 'Ellevest',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Ellevest.zip',
  },
  fidelity: {
    name: 'Fidelity',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Fidelity-Investments.zip',
  },
  flagstar: {
    name: 'Flagstar Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Flagstar-Bank.zip',
  },
  fundrise: {
    name: 'Fundrise',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Fundrise.zip',
  },
  geico: {
    name: 'GEICO',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Geico.zip',
  },
  guaranteedrate: {
    name: 'Guaranteed Rate',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Guaranteed-Rate.zip',
  },
  hrblock: {
    name: 'H&R Block Free',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/HR-Block-Free.zip',
  },
  ihg: {
    name: 'IHG Rewards Club',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/IHG_Rewards-Club.zip',
  },
  lightstream: {
    name: 'LightStream',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/LightStream.zip',
  },
  marcus: {
    name: 'Marcus',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Marcus_Goldman-Sachs.zip',
  },
  nasb: {
    name: 'North American Savings Bank',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/NASB.zip',
  },
  navyfederal: {
    name: 'Navy Federal',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Navy-Federal.zip',
  },
  onefinance: {
    name: 'One Finance',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/One-Finance.zip',
  },
  penfedpowered: {
    name: 'PenFed',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/PenFed_Purefy.zip',
  },
  primelending: {
    name: 'Prime Lending',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/PrimeLending.zip',
  },
  radius: {
    name: 'Radius Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Radius-Bank.zip',
  },
  sofi: {
    name: 'SoFi',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/SoFi.zip',
  },
  tdameritrade: {
    name: 'TD Ameritrade',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/TD-Ameritrade.zip',
  },
  turbotax: {
    name: 'TurboTax',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/TurboTax.zip',
  },
  upgrade: {
    name: 'Upgrade',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Upgrade.zip',
  },
  upstart: {
    name: 'Upstart',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Upstart.zip',
  },
  usbank: {
    name: 'U.S. Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/US-Bank.zip',
  },
  wellsfargo: {
    name: 'Wells Fargo',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Wells-Fargo.zip',
  },
  vanguard: {
    name: 'Vanguard Digital Advisor',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/Vanguard-Digital-Advisor.zip',
  },
  worldnomads: {
    name: 'World Nomads',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/World-Nomads.zip',
  },
  worldofhyatt: {
    name: 'World of Hyatt',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2021/badges/World-of-Hyatt.zip',
  },
};
